<div class="col-md-5" style="padding:10px">
  <button class="theme-button" matTooltip="After change setting and apply to kiosk" *ngIf="isAdmin"
    (click)="updateChannelMapping()">Apply Changes</button>
  <button class="theme-button" matTooltip="After change setting and apply to kiosk" *ngIf="isAdmin"
    [disabled]="saving" (click)="save()">{{ saving ? 'Saving...' : 'Save' }}</button>
  <mat-spinner *ngIf="saving" [diameter]="20" style="display: inline-block; margin-left: 10px;"></mat-spinner>
  
  <button *ngIf="offlineSync.hasPendingRequests()" class="warn-button" style="margin-left: 10px;"
    (click)="retryUpdates()" [disabled]="saving">
    Retry Pending ({{ offlineSync.getPendingRequests().length }})
  </button>
</div>

<!-- Mobile Floating Action Button -->
<div class="mobile-fab-container" *ngIf="appState.getIsMobileResolution() && isAdmin">
  <button *ngIf="offlineSync.hasPendingRequests()" class="fab-button" style="background-color: orange; color: white;" 
    (click)="retryUpdates()" [disabled]="saving">
    <mat-icon>sync</mat-icon>
  </button>
  <button class="fab-button fab-save" (click)="save()" [disabled]="saving">
    <mat-icon *ngIf="!saving">save</mat-icon>
    <mat-spinner *ngIf="saving" [diameter]="24" color="accent"></mat-spinner>
  </button>
</div>

<app-table-standard-layout [dataSource$]="combObs$" [title]="'Management'" [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton">
</app-table-standard-layout>
<div class="col-md-5" style="padding:10px">
  <button class="theme-button" matTooltip="After change setting and apply to kiosk" *ngIf="isAdmin"
    (click)="updateChannelMapping()">Apply Changes</button>

  <button class="theme-button" matTooltip="After change setting and apply to kiosk" *ngIf="isAdmin"
    [disabled]="saving" (click)="save()">{{ saving ? 'Saving...' : 'Save' }}</button>
  <mat-spinner *ngIf="saving" [diameter]="20" style="display: inline-block; margin-left: 10px;"></mat-spinner>

</div>